import { createReducer, on } from '@ngrx/store';

export interface SidebarTableViewState {
  title?: string;
  sidebar?: {
    label: string;
    attributes: any[];
  };
  tabs?: any[];
  tabLabels?: string[];
  activeTab?: any;
  datagrid: {
    columns: any[];
    data: any[];
  };
  filters?: any;
  backButton?: {
    label: string;
    route: string;
  };
  paginator?: {
    rowsPerPage: number;
    showingStart: number;
    showingEnd: number;
    currentPage: number;
    totalResults: number;
    totalPages: number;
    next: string;
    previous: string;
  };
  data: object[];
  error: string;
}

const initialSidebarTableViewState: SidebarTableViewState = {
  title: undefined,
  sidebar: undefined,
  datagrid: undefined,
  paginator: {
    rowsPerPage: undefined,
    showingStart: undefined,
    showingEnd: undefined,
    currentPage: undefined,
    totalResults: undefined,
    totalPages: undefined,
    next: undefined,
    previous: undefined,
  },
  tabs: undefined,
  tabLabels: undefined,
  activeTab: undefined,
  filters: undefined,
  backButton: undefined,
  data: undefined,
  error: undefined,
};

export const sidebarTableViewReducer = (
  getConfiguration,
  loadDatagridData,
  setActiveTab,
  setPaginatorCurrentPage,
  sortedSuccess,
  sortedError,
) =>
  createReducer(
    initialSidebarTableViewState,

    on(getConfiguration, (state, action) => {
      const config = action.config;
      let activeTab;
      let tabLabels;
      let datagrid;

      if (config.tabs) {
        activeTab = config.tabs[0];
        tabLabels = config.tabs.map((tab) => tab.label);
        datagrid = activeTab.datagrid;
      } else {
        activeTab = undefined;
        tabLabels = undefined;
        datagrid = config.datagrid;
      }

      return {
        title: config.title,
        sidebar: config.sidebar,
        tabs: config.tabs,
        activeTab: activeTab,
        tabLabels: tabLabels,
        datagrid: datagrid,
        filters: config.filters,
        backButton: config.backButton,
        paginator: {
          ...state.paginator,
          showingStart: 1,
          showingEnd: config.paginator,
          currentPage: 1,
          rowsPerPage: config.paginator,
        },
        data: undefined,
        error: undefined,
      };
    }),

    on(loadDatagridData, (state, action) =>
      action.payload
        ? {
            ...state,
            paginator: {
              ...state.paginator,
              totalResults: action.payload.count,
              totalPages: Math.ceil(
                action.payload.count / state.paginator.rowsPerPage,
              ),
            },
            datagrid: {
              ...state.datagrid,
              data: action.payload.results,
            },
          }
        : { ...state },
    ),

    on(setActiveTab, (state, action) => ({
      ...state,
      activeTab: action.tab,
      datagrid: action.tab.datagrid,
    })),

    on(setPaginatorCurrentPage, (state, action) => {
      const paginator = {
        ...state.paginator,
        currentPage: action.page,
        showingStart:
          action.page === 1
            ? 1
            : state.paginator.rowsPerPage * (action.page - 1) + 1,
        showingEnd:
          action.page === state.paginator.totalPages
            ? state.datagrid.data.length
            : state.paginator.rowsPerPage * action.page,
      };

      return {
        ...state,
        paginator: paginator,
      };
    }),

    on(sortedSuccess, (state, action) => ({
      ...state,
      datagrid: {
        ...state.datagrid,
        data: action.payload.results,
        columns: state.datagrid.columns,
      },
    })),

    on(sortedError, (state, action) => ({
      ...state,
      error: action.payload,
    })),
  );
